var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.showDialog)?_c('confirm-delete'):_vm._e(),_c('data-table'),(_vm.profileDialog)?_c('profile'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }